module.exports = __webpack_public_path__ + "static/media/calculator.8e4a5574.svg";